import { ItemAttribute } from '../../../../types/interfaces'
import classes from './DynamicSelect.module.sass'
import { FieldType, ValueType } from '../../../../types/enums'
import { useDynamicSelect } from './hooks/useDynamicSelect'
import close from '../../../../../assets/images/icons/close.svg'
import { unitTypeToText } from '../../../../utils/functions/enumToText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props = {
  el: ItemAttribute
  onChange: (id: string, value: string | string[] | boolean) => void
}

export const DynamicSelect = ({ el, onChange }: Props) => {
  // Используем хук ТОЛЬКО для мультиселекта
  const { arrayValue, setArrayValue } = useDynamicSelect(el)
  const dark = useSelector(selectDarkTheme)

  const isMultiselect = el.fieldType === FieldType.MULTISELECT

  return (
    <div className={classes.container}>
      <div className={classes.label}>{`${el.name}${
        el.valueType === ValueType.NUMBER ? `, ${unitTypeToText(el.unit)}` : ''
      }`}</div>

      <select
        // Для обычного селекта берем значение из el.value
        // Для мультиселекта всегда пустая строка (чтобы показывать placeholder)
        value={isMultiselect ? '' : el.value != null ? String(el.value) : ''}
        className={
          dark && el.isRequired
            ? classes.selectRequiredDark
            : dark
            ? classes.selectDark
            : el.isRequired
            ? classes.selectRequired
            : classes.select
        }
        onChange={(e) => {
          if (isMultiselect) {
            const selectedValue = e.target.value
            if (selectedValue) {
              setArrayValue((prev) => {
                const newArray = [...prev, selectedValue]
                onChange(String(el.id), newArray)
                return newArray
              })
            }
            // Сбрасываем select
            e.target.value = ''
          } else {
            onChange(String(el.id), e.target.value)
          }
        }}
      >
        <option value="">Выберите значение</option>
        {el.options
          .filter(
            (option) =>
              isMultiselect
                ? !arrayValue.includes(option) // Для мультиселекта скрываем уже выбранные
                : true, // Для обычного показываем все
          )
          .map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
      </select>

      {isMultiselect && (
        <div className={classes.items}>
          {arrayValue.map((item, index) => (
            <div key={`${item}-${index}`} className={classes.item}>
              {item}
              <img
                className={classes.del}
                src={close}
                alt="Удалить"
                onClick={() => {
                  setArrayValue((prev) => {
                    const newArray = prev.filter((_, i) => i !== index)
                    onChange(String(el.id), newArray)
                    return newArray
                  })
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
